(function ($) {
    function improveQuantityButtons() {
        const $quantity = $('.quantity .input-text');
        $quantity.each(function () {
            if ($(this).hasClass('improved')) return;

            $(this).addClass('improved');
            const $minus = $('<button type="button">-</button>').insertBefore($(this));
            $minus.on('click', () => {
                $(this)
                    .val(Math.max(parseInt($(this).val()) - 1, 0))
                    .trigger('change');
            });

            const $plus = $('<button type="button">+</button>').insertAfter($(this));
            $plus.on('click', () => {
                $(this)
                    .val(parseInt($(this).val()) + 1)
                    .trigger('change');
            });
        });
    }

    $(document).ready(improveQuantityButtons);

    $(document).on('improve-quantity-buttons', improveQuantityButtons);
    $(document).on('updated_wc_div', improveQuantityButtons);
    $(document).on('updated_checkout', improveQuantityButtons);
})(jQuery);
